import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AdvancedHealthCareDirective as SectionKey } from 'Consts/Questionnaire';
import CircleWithCount from 'Icons/CircleWithCount';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import Section from '../Section';
import FieldList from '../Fields/FieldList';
import TextInput from '../Fields/TextInput';
import DateInput from '../Fields/DateInput';
import USStateInput from '../Fields/USStateInput';

class AdvancedHealthCareDirectiveForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
    this.handleTitleChange = this.handleTitleChange.bind(this);
  }

  handleTitleChange(key, val) {
    this.setState({ title: val });
  }

  render() {
    const { title } = this.state;
    const {
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.25}
        title={title || 'New directive'}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <TextInput
          name={`advancedHealthCareDirectivePrincipal.${id}`}
          answerKey="advancedHealthCareDirectivePrincipal"
          placeholder="Principal"
          onChange={this.handleTitleChange}
          maxLength={64}
        />
        <DateInput
          name={`advancedHealthCareDirectiveDateExecuted.${id}`}
          answerKey="advancedHealthCareDirectiveDateExecuted"
          placeholder="Date executed"
        />
        <USStateInput
          name={`advancedHealthCareDirectiveStateExecuted.${id}`}
          answerKey="advancedHealthCareDirectiveStateExecuted"
          label="State in which executed:"
          value=""
          maxLength={32}
        />
        <TextInput
          name={`advancedHealthCareDirectivePrimaryAgent.${id}`}
          answerKey="advancedHealthCareDirectivePrimaryAgent"
          placeholder="Healthcare agent (primary)"
          maxLength={64}
        />
        <TextInput
          name={`advancedHealthCareDirectiveSuccessorAgent.${id}`}
          answerKey="advancedHealthCareDirectiveSuccessorAgent"
          placeholder="Healthcare agent (successor)"
          maxLength={64}
        />
      </LabeledVerticalExpander>
    );
  }
}

AdvancedHealthCareDirectiveForm.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.any.isRequired,
  expanded: PropTypes.bool,
};

AdvancedHealthCareDirectiveForm.defaultProps = {
  expanded: false,
};

const AdvancedHealthCareDirectiveSection = () => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      transitionSpeed={0.25}
      title="Advanced health care directive"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
    >
      <FieldList
        onCountUpdate={setCount}
        label="Advanced health care directives"
        addLabel="Add a directive"
        keyPrefix="advancedHealthCareDirective"
        Of={AdvancedHealthCareDirectiveForm}
      />
    </Section>
  );
};

export default AdvancedHealthCareDirectiveSection;
